import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import { uploadFile, resolveImg, formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";

export function ImageUploadField({ value, onChange, testid = "image", label = "Image" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const url = await uploadFile(file);
      onChange(url);
      toast.success("Image uploaded");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Upload failed");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      <div className="flex items-center gap-3">
        {value ? (
          <img src={resolveImg(value)} alt="" className="w-14 h-14 rounded-xl object-cover border border-[#0F172A]/10 shrink-0" />
        ) : (
          <div className="w-14 h-14 rounded-xl bg-[#E8E6E1] flex items-center justify-center text-[#475569] shrink-0"><Upload size={18} /></div>
        )}
        <div className="flex-1 flex gap-2">
          <Input
            data-testid={`${testid}-url`}
            placeholder="Paste image URL or upload"
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            className="border-[#0F172A]/10"
          />
          <button
            type="button"
            data-testid={`${testid}-upload-btn`}
            onClick={() => inputRef.current?.click()}
            disabled={uploading}
            className="shrink-0 inline-flex items-center gap-2 rounded-md bg-[#0F172A] text-white text-sm font-semibold px-4 hover:bg-[#1e293b] transition-colors disabled:opacity-60"
          >
            {uploading ? <Loader2 size={16} className="animate-spin" /> : <Upload size={16} />}
            {uploading ? "" : "Upload"}
          </button>
        </div>
      </div>
      <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" data-testid={`${testid}-file-input`} />
    </div>
  );
}
